import { Popup } from 'reactjs-popup';
import styled, { css } from 'styled-components';

import 'reactjs-popup/dist/index.css';

import { PopupProps } from './types';

export const StyledPopup = styled(Popup)<PopupProps>`
  ${({ theme, maxWidth }) => css`
    &-overlay {
      z-index: 2000 !important;
      background: rgba(${theme.colors.black.main}, 0.7);
    }

    &-content {
      max-width: ${maxWidth};
      padding: 0;
      border: none;
      background-color: transparent;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`;
